import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.define-property";
import "core-js/modules/web.dom-collections.for-each";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
/**
 * 外部容器
 *
 * 如果两页滑动的情况下
 *  - containerPageCount 3 总共3页
 *  - contentPageCount 2 2页内容滑动
 *  - containerPageIndex 1 当前显示页1
 *  - contentPageOffset 1 向左偏移页1
 */

var HorizontalSlideContainer =
/** @class */
function (_super) {
  __extends(HorizontalSlideContainer, _super);

  function HorizontalSlideContainer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(HorizontalSlideContainer.prototype, "containerPageX", {
    /**
     * 容器当前显示第几页，单位为%
     */
    get: function get() {
      return -(this.containerPageIndex / this.containerPageCount * 100).toFixed(4) + '%';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HorizontalSlideContainer.prototype, "contentPageLeft", {
    /**
     * 内容当前在容器的第几页开始，单位为%
     */
    get: function get() {
      return (this.contentPageOffset / this.containerPageCount * 100).toFixed(4) + '%';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HorizontalSlideContainer.prototype, "contentPageWidth", {
    /**
     * %
     */
    get: function get() {
      return (this.contentPageCount / this.containerPageCount * 100).toFixed(4) + '%';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HorizontalSlideContainer.prototype, "slidePageWidth", {
    /**
     * 每一页的宽度
     */
    get: function get() {
      return (1 / this.contentPageCount * 100).toFixed(4) + '%';
    },
    enumerable: false,
    configurable: true
  }); // @ts-ignore

  HorizontalSlideContainer.prototype.render = function (h) {
    var vm = this; // @ts-ignore

    var pages = this.$slots["default"].filter(function (vnode) {
      //  && vnode.tag.indexOf('SwiperSlide') != -1
      return vnode != null && vnode.tag != null;
    }); // 处理所有的slidePage

    pages.forEach(function (page) {
      if (!page.data) {
        page.data = {
          style: {
            width: vm.slidePageWidth
          }
        };
      }

      if (!page.data.style) {
        page.data.style = {
          width: vm.slidePageWidth
        };
        return;
      } // @ts-ignore


      page.data.style.width = vm.slidePageWidth;
    });
    var slideContent = h('div', {
      "class": ['horizontal-slide-content', 'clearfix'],
      style: {
        left: this.contentPageLeft,
        width: this.contentPageWidth,
        transform: "translate3d(-" + ((this.current * 1 / this.contentPageCount * 100).toFixed(4) + '%') + ", 0, 0)"
      }
    }, pages);
    var slideContainer = h('div', {
      "class": ['horizontal-slide-container'],
      style: {
        width: this.containerPageCount + '00%',
        transform: 'translate3d(' + this.containerPageX + ', 0, 0)'
      }
    }, [slideContent]);
    var slideWrap = h('div', {
      "class": ['horizontal-slide-wrap']
    }, [slideContainer]);
    return slideWrap;
  };

  __decorate([Prop({
    required: true,
    type: Number
  })], HorizontalSlideContainer.prototype, "current", void 0);

  __decorate([Prop({
    required: true,
    type: Number
  })], HorizontalSlideContainer.prototype, "containerPageCount", void 0);

  __decorate([Prop({
    required: true,
    type: Number
  })], HorizontalSlideContainer.prototype, "contentPageCount", void 0);

  __decorate([Prop({
    required: true,
    type: Number,
    "default": 0
  })], HorizontalSlideContainer.prototype, "containerPageIndex", void 0);

  __decorate([Prop({
    required: true,
    type: Number,
    "default": 0
  })], HorizontalSlideContainer.prototype, "contentPageOffset", void 0);

  HorizontalSlideContainer = __decorate([Component({
    name: 'HorizontalSlideContainer'
  })], HorizontalSlideContainer);
  return HorizontalSlideContainer;
}(Vue);

export default HorizontalSlideContainer;